import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CostModule } from './pages/cost/cost.module';
import { GuardService } from 'app/shared/services/guard/guard.service';
import { RetailModule } from "./pages/retail/retail.module";
import { EQuotationEntryPoints } from "libraries/enums/e-quotation-entry-points";

const routes: Routes = [

    {
        path: `:id`,
        loadChildren: () => import('./pages/cost/cost.module').then(m => m.CostModule),
        canActivate: [ GuardService ],
    },
    {
        path: `:id/${EQuotationEntryPoints.cost}`,
        loadChildren: () => import('./pages/cost/cost.module').then(m => m.CostModule),
        canActivate: [ GuardService ],
    },
    {
        path: `:id/${EQuotationEntryPoints.retail}`,
        loadChildren: () => import('./pages/retail/retail.module').then(m => m.RetailModule),
        canActivate: [ GuardService ],
    },
    {
        path: '**',
        loadChildren: () => import('./pages/cost/cost.module').then(m => m.CostModule),
        canActivate: [ GuardService ],
    },
];

@NgModule({
    imports: [
        CostModule,
        RetailModule,
        RouterModule.forChild(routes),
    ],
    exports: [
        RouterModule,
    ],
})
export class QuotationRoutingModule {
}
